// extracted by mini-css-extract-plugin
module.exports = {"spacing_bottom":"ads_spacing_bottom__JbYwD"};